import { render } from "./ResellerCustomers.vue?vue&type=template&id=52c07553"
import script from "./ResellerCustomers.vue?vue&type=script&lang=js"
export * from "./ResellerCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__